import * as util from 'util';
import parseAddress from 'parse-address';
import { findAnswer } from '../../../state/questionStates';

const FULL_CONFIDENCE = ",100";

var removeSymbols = function(obj) {
    if (obj && obj.value) {
        obj.value = obj.value.replace(/\$|,|\s/g, "");
    }

    return obj;
};

var ensure = function(val, prepend) {
    let result = val ? val : "";
    if (prepend) {
        return prepend + result;
    }
    return result;
}

var ensureConfidence = function(obj) {
    if (obj && "confidence" in obj) {
        return "," + parseInt(Math.trunc(obj.confidence));
    }
    return "";
}

var constructQueryString = function(store, question) {
    let state = store.getState();
    let queryString = "command=get_quote&first_name=%s%s&last_name=%s%s&birthday=%s%s&premium=%s%s&home_rent=%s%s&deductible=%s%s&coverage_a=%s%s" +
            "&coverage_b=%s%s&coverage_c=%s%s&coverage_d=%s%s&coverage_e=%s%s&coverage_f=%s%s&zip=%s%s&effective_date=%s%s&city=%s%s&state=%s%s" +
            "&address_1=%s%s";

    let firstName = findAnswer(state, "name", "firstName");
    let lastName = findAnswer(state, "name", "lastName");
    let dob = findAnswer(state, "dob", "dateOfBirth");
    let premiumTotal = removeSymbols(findAnswer(state, "review", "premium"));
    let homeRent = findAnswer(state, "home-rent", "homeOrRental");
    homeRent.value = homeRent.value === "Homeowners" ? "home" : "rent";
    let deductible = removeSymbols(findAnswer(state, "review", "deductible"));
    let coverageA = removeSymbols(findAnswer(state, "review", "coverage_a"));
    let coverageB = removeSymbols(findAnswer(state, "review", "coverage_b"));
    let coverageC = removeSymbols(findAnswer(state, "review", "coverage_c"));
    let coverageD = removeSymbols(findAnswer(state, "review", "coverage_d"));
    let coverageE = removeSymbols(findAnswer(state, "review", "coverage_e"));
    let coverageF = removeSymbols(findAnswer(state, "review", "coverage_f"));
    let address = findAnswer(state, "review", "address");
    let parsedAddress = parseAddress.parseLocation(address.value);
    let effectiveDate = findAnswer(state, "review", "effective_date");

    console.log(JSON.stringify(firstName));
    console.log(JSON.stringify(lastName));
    console.log(JSON.stringify(dob));
    console.log(JSON.stringify(premiumTotal));
    console.log(JSON.stringify(homeRent));
    console.log(JSON.stringify(deductible));
    console.log(JSON.stringify(coverageA));
    console.log(JSON.stringify(coverageB));
    console.log(JSON.stringify(coverageC));
    console.log(JSON.stringify(coverageD));
    console.log(JSON.stringify(coverageE));
    console.log(JSON.stringify(coverageF));
    console.log(JSON.stringify(address));
    console.log(JSON.stringify(effectiveDate));

    return encodeURI(util.format(queryString,
        ensure(firstName.value.toLowerCase()), FULL_CONFIDENCE, //ensureConfidence(firstName),
        ensure(lastName.value.toLowerCase()), FULL_CONFIDENCE, //ensureConfidence(lastName),
        ensure(dob.value), FULL_CONFIDENCE, //ensureConfidence(dob),
        ensure(premiumTotal.value), ensureConfidence(premiumTotal),
        ensure(homeRent.value), FULL_CONFIDENCE, //ensureConfidence(homeRent),
        ensure(deductible.value), ensureConfidence(deductible),
        ensure(coverageA.value), ensureConfidence(coverageA),
        ensure(coverageB.value), ensureConfidence(coverageB),
        ensure(coverageC.value), ensureConfidence(coverageC),
        ensure(coverageD.value), ensureConfidence(coverageD),
        ensure(coverageE.value), ensureConfidence(coverageE),
        ensure(coverageF.value), ensureConfidence(coverageF),
        ensure(parsedAddress ? parsedAddress.zip : ""), ensureConfidence(address),
        ensure(effectiveDate ? effectiveDate.value : ""), ensureConfidence(effectiveDate),
        ensure(parsedAddress ? parsedAddress.city : ""), ensureConfidence(address),
        ensure(parsedAddress ? parsedAddress.state : ""), ensureConfidence(address),
        ensure(parsedAddress ? parsedAddress.number : "") + ensure(parsedAddress ? parsedAddress.street : "", " ") + ensure(parsedAddress ? parsedAddress.type : "", " "), ensureConfidence(address)
    ));
};

var handleResult = function(result, store, question) {
    let email = findAnswer(store.getState(), "email", "email");
    result.data.email = email.value;
};

export {
    constructQueryString,
    handleResult
};